import type { PropietarioContrato } from '@/types/contrato';

type Owner = Pick<PropietarioContrato, 'retiene_irpf' | 'residencia'>;
export interface IrpfConfig {
  irpf_minimo_imponible?: string | number | null;
  irpf_minimo_imponible_usd?: string | number | null;
}

export function alwaysRetainsIrpf(owner: Owner): boolean {
  const residence = (owner.residencia ?? 'Uruguay').trim().toLowerCase();
  return !!owner.retiene_irpf || !['', 'uruguay', 'uy'].includes(residence);
}

/** null means the threshold for this currency still needs configuration. */
export function ownerIrpfStatus(owner: Owner, monthlyRent: number, currency: string, config: IrpfConfig): boolean | null {
  if (alwaysRetainsIrpf(owner)) return true;
  const raw = currency === 'USD' ? config.irpf_minimo_imponible_usd : (config.irpf_minimo_imponible === undefined ? 21290 : config.irpf_minimo_imponible);
  if (raw === undefined || raw === null || String(raw).trim() === '' || !Number.isFinite(Number(raw)) || Number(raw) < 0) return null;
  return Math.round(monthlyRent * 100) / 100 >= Number(raw);
}
